import React from "react";
import "./searchinput.css";
import { DebounceInput } from "react-debounce-input";
import { SearchOutlined } from "@mui/icons-material";
import { Input } from 'antd';

const SearchInput = ({ searchQuery, setSearchQuery, cssClass, searchPlaceholder }) => {
  return (
    <div className={cssClass}>
      <DebounceInput
        className="searchFilter"
        type="text"
        placeholder={searchPlaceholder}
        value={searchQuery}
        minLength={1}
        debounceTimeout={500}
        onChange={(event) => {
          setSearchQuery(event.target.value.trim());
        }}
        suffix={<SearchOutlined className="searchIcon" />}
        element={Input}
      />
    </div>
  );
};

export default SearchInput;
